import { FavoriteMatchesQueryKeys } from "@/tanstackQuery/queries/favoriteMatches";
import { addFavoriteMatch, deleteFavoriteMatch } from "@/api/favoriteMatches";
import { useToggleMutation } from "../hooks";

// Optimistic add/remove of a favorite match. The "entity" is the match (event)
// id, so getSelectionKey is identity. Mirrors useTogglePinnedMarket.
export const useToggleFavoriteMatch = () =>
  useToggleMutation<number>({
    queryKey: [FavoriteMatchesQueryKeys.All],
    addMutationFn: addFavoriteMatch,
    deleteMutationFn: deleteFavoriteMatch,
    getSelectionKey: (matchId) => matchId,
    updateOptions: { preventRefetchOnSettled: true }
  });
